import React, {useState} from 'react';
import { Container, Navbar, Nav, Button, Row, Col, Card, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../custom.css';
import ReCAPTCHA from "react-google-recaptcha";
import logo from '../assets/orbyte.png';
import logo2 from '../assets/orbyethick.png';
import ContactForm from "./ContactForm";

const LandingPage = () => {
    return (
        <>
            {/* Navbar */}
            <Navbar expand="lg" className="bg-dark bg-opacity-75 shadow-sm fixed-top">
                <Container>
                    <Navbar.Brand href="#home">
                        <img src={logo2} alt="Orbyte" style={{maxHeight: '30px'}}/>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbar-nav"/>
                    <Navbar.Collapse id="navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link href="#features" className="text-light">Features</Nav.Link>
                            <Nav.Link href="#about" className="text-light">About</Nav.Link>
                            <Nav.Link href="#contact" className="text-light">Contact</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-overlay"></div>
                <Container className="hero-content">
                    <h1 className="display-3 fw-bold">The Future of Digital Solutions Starts Here.</h1>
                    <p className="lead fs-4">Empowering businesses with advanced technology, intelligent automation, and
                        human innovation.</p>
                    <Button variant="light" size="lg" href="#contact" className="mt-4 shadow">Start Your
                        Journey</Button>
                </Container>
            </section>


            {/* Features Section */}
            <section id="features" className="py-5 bg-light">
                <Container className="container-lg text-center">
                    <h2 className="fw-bold mb-5">How We Help Businesses Succeed</h2>
                    <Row className="row-cols-1 row-cols-md-3 g-4">
                        <Col>
                            <Card className="border-0 shadow-lg p-4 feature-card">
                                <Card.Body className="d-flex flex-column align-items-center">
                                    <i className="bi bi-lightbulb text-primary fs-1 mb-3"></i>
                                    <Card.Title className="fw-bold fs-4">Smart Solutions</Card.Title>
                                    <Card.Text className="text-muted">We design software that makes sense—clear,
                                        effective, and easy to use.</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className="border-0 shadow-lg p-4 feature-card">
                                <Card.Body className="d-flex flex-column align-items-center">
                                    <i className="bi bi-people text-primary fs-1 mb-3"></i>
                                    <Card.Title className="fw-bold fs-4">Consulting & Strategy</Card.Title>
                                    <Card.Text className="text-muted">We help businesses make informed tech decisions
                                        that drive results.</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className="border-0 shadow-lg p-4 feature-card">
                                <Card.Body className="d-flex flex-column align-items-center">
                                    <i className="bi bi-cpu text-primary fs-1 mb-3"></i>
                                    <Card.Title className="fw-bold fs-4">Future-Ready Tech</Card.Title>
                                    <Card.Text className="text-muted">We embrace new ideas and technology—but only when
                                        they actually work.</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* About Section */}
            <section id="about" className="py-5 bg-light">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6} className="text-center text-md-start">
                            <h2 className="fw-bold mb-4">About Orbyte</h2>
                            <p className="text-muted fs-5">
                                Orbyte is a modern technology company focused on solving complex problems with simple,
                                intuitive solutions.
                                We believe that software should work for people—not the other way around.
                            </p>
                            <p className="text-muted fs-5">
                                Our approach is straightforward: we analyze challenges, explore possibilities, and
                                create technology that makes sense.
                                Whether it’s through **custom software development** or **strategic consulting**, we
                                help businesses find the right path forward.
                            </p>
                            <p className="text-muted fs-5">
                                We don’t chase trends—we build solutions that last.
                            </p>
                        </Col>
                        <Col md={6} className="text-center">
                            <img src="https://cdn.pixabay.com/photo/2016/08/05/07/17/laptop-1571702_1280.jpg"
                                 alt="Orbyte Team" className="img-fluid rounded shadow-lg"/>
                        </Col>
                    </Row>
                </Container>
            </section>


            {/* Contact Section */}
            <section id="contact" className="py-5 bg-dark text-white">
                <Container>
                    <h2 className="text-center fw-bold mb-4">Get in Touch</h2>
                    <ContactForm/>
                </Container>
            </section>

            {/* Footer */}
            <footer className="py-3 text-center bg-dark text-white">
                <Container>
                    <p className="mb-0">&copy; {new Date().getFullYear()} Orbyte Örebro. All rights reserved.</p>
                </Container>
            </footer>
        </>
    );
};

export default LandingPage;
